import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

import StatsTab from "./components/StatsTab";
import CallsTable from "./components/CallsTable";
import PromptTodoList from "./components/PromptTodoList";
import CategoriesList from "./components/CategoriesList";

function App() {
  const [isAuth, setIsAuth] = useState("");

  // 🔹 Check token or flag in localStorage on load
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    console.log("🔑 Token in localStorage:", token);
    if (token) setIsAuth(token);
  }, []);

  // 🔹 When login succeeds
  const handleLogin = (token) => {
    localStorage.setItem("auth_token", token);
    setIsAuth(token);
  };

  // 🔹 When logout
  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setIsAuth("");
  };

  return (
    <Router>
      <Routes>
        {/* Login Page */}
        <Route
          path="/login"
          element={
            !isAuth ? (
              <Login setIsAuth={handleLogin} />
            ) : (
              <Navigate to="/dashboard/stats" replace />
            )
          }
        />

        {/* Protected Dashboard */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <Dashboard handleLogout={handleLogout} />
            </ProtectedRoute>
          }
        >
          <Route path="stats" element={<StatsTab />} />
          <Route path="gptPrompt" element={<PromptTodoList />} />
          <Route path="gestion-categories" element={<CategoriesList />} />
          <Route path="transcriptions/calls" element={<CallsTable />} />
        </Route>

        {/* Default redirect */}
        <Route
          path="*"
          element={<Navigate to={isAuth ? "/dashboard/stats" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
